// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  googleMapStyle: () => ({
    "& .gm-style .gm-style-cc a, .gm-style .gm-style-cc button, .gm-style .gm-style-cc span":
      {
        display: "none !important",
      },
    height: "112% !important",
    borderRadius: "20px",
    boxShadow: "0px 6px 6px #d0cbcb",
    "& button": {
      // display: "none !important",
      outline: "none !important",
      marginBottom: "-10px !important",
      marginRight: "-10px !important"
    },
  }),
  infoWindow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start", // Align content to the left
    justifyContent: "flex-start", // Content stays at the top
    gap: "10px",
    minWidth: "220px",
    maxWidth: "auto",
    minHeight: "80%",
    padding: "12px",
    borderRadius: "8px",
    background: "transparent",
    position: "relative",
    wordWrap: "break-word",
  },

  communityName: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "8px",
    wordWrap: "break-word",
    whiteSpace: "normal",
  },

  communityDescription: {
    fontSize: "14px",
    color: "#666",
    wordWrap: "break-word",
    whiteSpace: "normal", // Allow description to wrap properly
  },

  communityImage: {
    width: "100px",
    borderRadius: "20px",
    height: "100px"
  }
});

export default useStyles;
